<template>
<div class='technology-name-table-cell'>
  <span class='technology-name-table-cell__icon'>
    <span v-if="!icon || errorOccurred" class="material-icons-outlined">
      widgets
    </span>
    <v-img :src="icon" @error='errorOccurred = true'/>
  </span>
  <span class='technology-name-table-cell__name' :title='item[column.field]'>
    {{ item[column.field] }}
  </span>
</div>
</template>

<script>
import indexDB from '@/assets/tech-metadata/index-db.json';
import technologiesKeys from '@/constants/technologies';

export default {
  name: 'TechnologyNameTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      errorOccurred: false,
    };
  },
  computed: {
    formattedTechName() {
      const techName = this.item[this.column.field];
      let formattedTechnologyName = techName.toLowerCase().replaceAll(' ', '-').replace('.', '');
      if (Object.keys(indexDB).includes(formattedTechnologyName)) {
        if (Object.keys(indexDB[formattedTechnologyName]).includes(technologiesKeys.ref)) {
          formattedTechnologyName = indexDB[formattedTechnologyName][technologiesKeys.ref];
        }
      }
      return formattedTechnologyName;
    },

    icon() {
      let techIcon = null;
      function getIconFromIndexDB(techName) {
        try {
          // eslint-disable-next-line global-require,import/no-dynamic-require
          return require(`@/assets/tech-metadata/${techName}`);
        } catch (e) {
          return null;
        }
      }

      if (Object.keys(indexDB).includes(this.formattedTechName)) {
        if (Object.keys(indexDB[this.formattedTechName]).includes(technologiesKeys.ref)) {
          techIcon = getIconFromIndexDB(indexDB[indexDB[this.formattedTechName][technologiesKeys.ref].text()].icon);
        } else {
          techIcon = getIconFromIndexDB(indexDB[this.formattedTechName][technologiesKeys.icon]);
        }
      }
      return techIcon;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.technology-name-table-cell {
  display: flex;
  max-width: 80%;
  padding-left: 2.5%;

  &__icon {
    display: flex;
    float: left;
    margin-top: $space-1;
    margin-right: rem(13);

    .v-image {
      width: rem(20);
    }

    .material-icons-outlined {
      font-size: rem(20);
      width: 0;
    }
  }

  &__name {
    z-index: 3;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: var(--text-primary);
    font-family: $font-family-semibold;
    font-size: $font-size-base;
    font-weight: 600;
    letter-spacing: 0;
    line-height: rem(17);
    text-transform: capitalize;
  }
}
</style>
